import { RiRestartLine } from '@remixicon/react';
import { useEffect, useState } from 'react';
import Button from '../../../../components/ui/button';
import { sentryCapture } from '../../../../helpers/utils';
import { useApi } from '../../../../hooks/useApi';
import { useTokenStore } from '../../../../store/token';
import { SentryError } from '../../../../types/enums';
import { experiencieBagdetTableView } from '../../../../types/experiencieBagdet';
import { ParticipantsEnroll } from '../../../../types/types';

interface iParticipants {
	tournamentStatus: number;
	tournamentPickId: string;
}

const thead = [
	{
		title: 'Inscrição',
	},
	{
		title: 'Posição',
	},
	{
		title: 'Pontos',
	},
	{
		title: 'Prêmio',
	},
];

export const ParticipantsPicks = ({
	tournamentStatus,
	tournamentPickId,
}: iParticipants) => {
	const api = useApi();
	const token = useTokenStore((state: any) => state.token);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [page, setPage] = useState(0);
	const [isLoading, setIsLoading] = useState(false);
	const [participants, setParticipants] = useState<any>([]);

	const limit = page === 0 ? 20 : 100;
	const offset = page === 0 ? 0 : 20 + (page - 1) * 100;

	useEffect(() => {
		fetchParticipants();
	}, []);

	const fetchParticipants = async () => {
		try {
			setLoading(true);

			const res = await api.getParticipantsPick(
				tournamentPickId,
				limit,
				offset,
				token
			);
			if (!res?.success) {
				throw new Error(res.message);
			}

			setPage((prevPage) => prevPage + 1);
			setParticipants((prevFeed: any) => [
				...prevFeed,
				...res.data.participants,
			]);

			if (res.currentPage >= res.totalPages) {
				setHasMore(false);
				return;
			}
		} catch (error: any) {
			sentryCapture(error, 'fetchParticipants', SentryError.Error);
		} finally {
			setLoading(false);
		}
	};

	const handleLoadMore = async () => {
		try {
			setIsLoading(true);

			const res = await api.getParticipantsPick(
				tournamentPickId,
				limit,
				offset,
				token
			);
			if (!res?.success) {
				throw new Error(res.message);
			}

			setParticipants((prevFeed: any) => [
				...prevFeed,
				...res.data.participants,
			]);
			setPage((prevPage) => prevPage + 1);
			if (res.currentPage >= res.totalPages) {
				setHasMore(false);
				return;
			}
		} catch (error: any) {
			sentryCapture(error, 'fetchParticipants', SentryError.Error);
		} finally {
			setIsLoading(false);
		}
	};

	if (loading) {
		return (
			<div className="flex items-center justify-center">
				<RiRestartLine className="mr-2 h-4 w-4 animate-spin" />
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-2">
			<div className="flex w-full flex-col">
				{participants.length > 0 ? (
					participants.map(
						(item: ParticipantsEnroll, index: number) => (
							<div
								key={index}
								className="p-1 flex flex-row items-center justify-between text-center self-stretch text-black text-[12px] max-[330px]:text-[10px] font-medium font-bahnschrift leading-[10px]"
							>
								<div className="inline-flex justify-start items-center">
									{item.nick.toLowerCase()}
								</div>
								<div className="w-40 inline-flex justify-end">
									{experiencieBagdetTableView(
										item.experience
									)}
								</div>
							</div>
						)
					)
				) : (
					<div className="text-neutral-400 text-xs font-light font-bahnschrift leading-tight">
						Por enquanto tá vazio por aqui... Bora movimentar isso!
						Se inscreve aí e vem participar com a gente!
					</div>
				)}
			</div>

			{hasMore && (
				<Button
					isLoading={isLoading}
					onClick={handleLoadMore}
					className="w-full px-3.5 py-3.5 mb-6"
				>
					Carregar mais
				</Button>
			)}
		</div>
	);
};
